import React from 'react';
import {Spinner} from '@tkww/orion-web-ds-feedback';
import styles from './index.scss';

const FullPageSpinner = () => (
  <div data-testid="spinner-container" className={styles['spinner-container']}>
    <Spinner size="lg" styleType="primary" />
  </div>
);

export default FullPageSpinner;
